'use strict';

export { default } from './collectionSelect.component';
